export interface WaitForDocumentReadyOptions {
    signal?: AbortSignal;
}

/**
 * Runs a callback when document.readyState is 'complete' or 'interactive' or 'DOMContentLoaded' event is fired.
 *
 * @param doc document to wait for
 * @param callback a callback to run
 * @param options options for the event listener
 */
export const waitForDocumentReady = (doc: Document, callback: () => void, options?: WaitForDocumentReadyOptions): void => {
    if (doc.readyState === 'loading') {
        doc.addEventListener('DOMContentLoaded', callback, { ...options, once: true });
    } else {
        callback();
    }
};

/**
 * Returns a promise that resolves when document.readyState is 'complete' or 'interactive' or 'DOMContentLoaded' event is fired.
 *
 * @param doc document to wait for
 * @returns a promise that resolves when document.readyState is 'complete' or 'interactive' or 'DOMContentLoaded' event is fired.
 */
export const waitForDocumentReadyPromise = (doc: Document) => new Promise<void>(resolve => waitForDocumentReady(doc, resolve));
